import { render } from "./App.vue?vue&type=template&id=7d4b401c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7d4b401c&lang=css"

import exportComponent from "D:\\Programas\\laragon\\www\\projects\\vuejs\\adivina\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__